<template>
  <div class="board_wrap">
    <div class="board_title">
      <h1>물류/차량 관리 시스템</h1>
    </div>
    <div class="product">
      
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style>
.product {
  border-top: solid 2px;
}
</style>
